export function getAllTags(projects) {
  const tags = new Set();

  projects.forEach((project) => {
    project.tags?.forEach((tag) => {
      tags.add(tag);
    });
  });

  return Array.from(tags).sort();
}

export function filterProjects(projects, selectedTag) {
  if (!selectedTag || selectedTag === "ALL") {
    return projects;
  }

  return projects.filter((project) =>
    project.tags?.includes(selectedTag)
  );
}